import React, { useState, useEffect, useContext } from 'react';
import SVG from "react-inlinesvg";
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import InputMask from 'react-input-mask';
import validationMessage from '../helpers/ValidationErrorMsg'

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

const LogBookRunningHourEntry = () => {
    const { jwt } = useContext(AppContext);
    const [state, setState] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: "",
        operator: "",
        logDate: "",
        startingHrs: "",
        endingHrs: "",
        workSiteName: "",
        majorTasks: "",
        boqItems: "",
        runningHrs: { hrs: "", mins: "", runningHrs: "" },
        workType: "",
        workDetails: "",
        workTypeList: [],
        workDetailsList: [],
        allBusinessUnits: [],
        isMultipleTimeEntries: false,
        timeEntries: [{ startTime: "", endTime: "" }]
    });

    useEffect(() => {
        getAllBu();
    }, []);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_user_business_units",
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let tempResp = resp.data.map(function (element) {
                    return { ...element, label: element.projectName, value: element.projectId, isdisabled: element.projectName === 'EMD' ? false : true }
                });
                setState(prev => ({ ...prev, allBusinessUnits: tempResp }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    const getEquipment = (inputValue, callback) => {
        if (!state.logBookBusinessUnit?.projectId || !state.logDate) {
            callback([]);
            return;
        }
        
        if (!inputValue) {
            callback([]);
        } else {
            //var url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + state.logBookBusinessUnit.projectId + "?q=" + inputValue;

            var url = process.env.REACT_APP_API_URL + "equipment/log_book_equipment_search/" + state.logBookBusinessUnit.projectId + "/" + state.logDate + "?q=" + inputValue;

            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.equipmentName} (${element.equipmentCode})`;
                            element.value = element.equipmentId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const handleEquipmentChange = equipment => {
        setState(prev => ({ 
            ...prev, 
            equipment: equipment, 
            startingHrs: equipment.closingHrsMeter
        }));
    }

    useEffect(() => {
        if (state.projectId) {
            getWorkType(state.projectId);
        }
    }, [state.projectId]);

    const handleBuChange = logBookBusinessUnit => {
        setState(prev => ({ ...prev, logBookBusinessUnit, projectId: logBookBusinessUnit.projectId, workTypeList: [], workDetailsList: [] ,workType: {}, workDetails: {} }));
    }

    const getWorkType = (projectId) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/task/${projectId}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.tasks.map(function (element) {
                    element.label = element.taskName;
                    element.value = element.idDashboardEquipmentMajorTasks;
                    return element;
                });
                setState(prev => ({ ...prev, workTypeList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    const getWorkDetails = (idDashboardEquipmentMajorTasks) => {
        fetch(process.env.REACT_APP_DASHBOARD_URL + `app/boqItem/${idDashboardEquipmentMajorTasks}`,
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempArray = resp.boqItems.map(function (element) {
                    element.label = `${element.description} (${element.boqId})`;
                    element.value = element.idDashboardEquipmentBoqItems;
                    return element;
                });
                setState(prev => ({ ...prev, workDetailsList: tempArray }));
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    useEffect(() => {
        if (state.workType?.value) {
            getWorkDetails(state.workType.value);
        }
    }, [state.workType]);

    const getOperatorName = (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
        } else {
            var url = process.env.REACT_APP_API_URL + "search_operator?q=" + inputValue;
            setTimeout(() => {
                fetch(url, getGetRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.name} (${element.phone})`;
                            element.value = element.id;
                            element.operatorId = element.id;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const handleOperatorNameChange = operatorName => {
        setState(prev => ({ ...prev, operator: operatorName }));
    }

    const handleInputOnChange = (name, value) => {
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleWorkTypeChange = workType => {
        setState(prev => ({ 
            ...prev, 
            workType: workType, 
            workDetails: {}, 
            workDetailsList: [] 
        }));
    }

    const handleWorkDetailsChange = workDetails => {
        setState(prev => ({ ...prev, workDetails: workDetails }));
    }

    const handleHourChange = (evt) => {
        const value = evt.target.value;
        if (value > 24) {
            return;
        }
        setState(prev => ({
            ...prev,
            runningHrs: {
                ...prev.runningHrs,
                hrs: value,
                runningHrs: `${value.padStart(2, '0')}:${prev.runningHrs.mins ? prev.runningHrs.mins.padStart(2, '0') : '00'}`
            }
        }));
    }

    const handleMinuteChange = (evt) => {
        const value = evt.target.value;
        if (value > 59) {
            return;
        }
        setState(prev => ({
            ...prev,
            runningHrs: {
                ...prev.runningHrs,
                mins: value,
                runningHrs: `${prev.runningHrs.hrs ? prev.runningHrs.hrs.padStart(2, '0') : '00'}:${value.padStart(2, '0')}`
            }
        }));
    }

    const handleMultipleTimeEntriesChange = (checked) => {
        setState(prev => ({
            ...prev,
            isMultipleTimeEntries: checked,
            timeEntries: checked ? [{ startTime: "", endTime: "" }] : []
        }));
    };

    const addTimeEntry = () => {
        setState(prev => ({
            ...prev,
            timeEntries: [...prev.timeEntries, { startTime: "", endTime: "" }]
        }));
    };

    const removeTimeEntry = (index) => {
        setState(prev => ({
            ...prev,
            timeEntries: prev.timeEntries.filter((_, i) => i !== index)
        }));
    };

    const calculateHoursBetween = (startTime, endTime) => {
        // Convert 12-hour format to 24-hour format
        const convertTo24Hour = (time) => {
            const [timeStr, period] = time.split(' ');
            let [hours, minutes] = timeStr.split(':').map(Number);
            
            // Handle AM/PM conversion
            if (period === 'PM' && hours !== 12) {
                hours += 12;
            } else if (period === 'AM' && hours === 12) {
                hours = 0;
            }
            
            return [hours, minutes];
        };

        const [startHours, startMinutes] = convertTo24Hour(startTime);
        const [endHours, endMinutes] = convertTo24Hour(endTime);
        
        let totalMinutes = (endHours * 60 + endMinutes) - (startHours * 60 + startMinutes);
        
        // If end time is on the next day, add 24 hours
        if (totalMinutes < 0) {
            totalMinutes += 24 * 60;
        }
        
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    const handleTimeEntryChange = (index, field) => (evt) => {
        const newTimeEntries = [...state.timeEntries];
        newTimeEntries[index][field] = evt.target.value;
        setState(prev => ({
            ...prev,
            timeEntries: newTimeEntries
        }));
    };

    useEffect(() => {
        if (state.timeEntries.every(entry => entry.startTime && entry.endTime)) {
            let totalMinutes = 0;
            
            state.timeEntries.forEach(entry => {
                const [startHours, startMinutes] = entry.startTime.split(':').map(Number);
                const [endHours, endMinutes] = entry.endTime.split(':').map(Number);
                
                let startTotalMinutes = startHours * 60 + startMinutes;
                let endTotalMinutes = endHours * 60 + endMinutes;
                
                // If end time is on the next day, add 24 hours
                if (endTotalMinutes < startTotalMinutes) {
                    endTotalMinutes += 24 * 60;
                }
                
                totalMinutes += endTotalMinutes - startTotalMinutes;
            });

            const totalHours = Math.floor(totalMinutes / 60);
            const remainingMinutes = totalMinutes % 60;
            
            setState(prev => ({
                ...prev,
                runningHrs: {
                    hrs: totalHours.toString(),
                    mins: remainingMinutes.toString(),
                    runningHrs: `${totalHours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`
                }
            }));
        }
    }, [state.timeEntries]);

    const handleSubmit = evt => {
        evt.preventDefault();

        // Format running hours to match HH:mm format
        const formattedRunningHrs = `${state.runningHrs.hrs.padStart(2, '0')}:${state.runningHrs.mins.padStart(2, '0')}`;

        // Calculate hours for each time entry if multiple entries exist
        const timeEntriesWithHours = state.isMultipleTimeEntries 
            ? state.timeEntries.map(entry => ({
                ...entry,
                hour: calculateHoursBetween(entry.startTime, entry.endTime)
            }))
            : [];

        const formData = {
            projectId: state.logBookBusinessUnit.value,
            equipment: {
                equipmentId: state.equipment.value,
                equipmentName: state.equipment.equipmentName
            },
            logDate: state.logDate,
            startingHrs: parseFloat(state.startingHrs),
            endingHrs: parseFloat(state.endingHrs),
            workSiteName: state.workSiteName,
            idDashboardEquipmentMajorTasks: state.workType.value,
            idDashboardEquipmentBoqItems: state.workDetails.value,
            operator: {
                id: state.operator.value,
                name: state.operator.name
            },
            runningHrs: {
                hrs: state.runningHrs.hrs.padStart(2, '0'),
                mins: state.runningHrs.mins.padStart(2, '0'),
                runningHrs: formattedRunningHrs
            },
            isMultipleTimeEntries: state.isMultipleTimeEntries,
            timeEntries: state.isMultipleTimeEntries ? timeEntriesWithHours : []
        };

        Swal.fire({
            title: 'Are you sure?',
            text: "You want to entry this running hour!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt.token },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/running_hour_entry", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            let successMsg = resp.successMessage;
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: successMsg,
                            })

                            setState({
                                logBookBusinessUnit: "",
                                projectId: "",
                                equipment: "",
                                operator: "",
                                logDate: "",
                                startingHrs: "",
                                endingHrs: "",
                                workSiteName: "",
                                majorTasks: "",
                                boqItems: "",
                                runningHrs: { hrs: "", mins: "", runningHrs: "" },
                                workType: "",
                                workDetails: "",
                                workTypeList: [],
                                workDetailsList: [],
                                allBusinessUnits: state.allBusinessUnits,
                                isMultipleTimeEntries: false,
                                timeEntries: [{ startTime: "", endTime: "" }]
                            });
                        } else {
                          
                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
							Swal.fire({
								icon: 'error',
								title: 'Error',
								html: errorsMessage,
							})
                        }
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop");
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while submitting the form',
                        });
                    });
            }
        });
    }

    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">
                        <p className="text-primary">
                            Running Hour Entry
                        </p>
                    </h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="card-body">
                        <div className="ml-12">
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Business Unit<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <Select
                                                value={state.logBookBusinessUnit}
                                                onChange={handleBuChange}
                                                options={state.allBusinessUnits}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="logDate" className="col-lg-2 col-form-label">Log Date<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input type="date" name="logDate" id="logDate" value={state.logDate} onChange={(e) => handleInputOnChange('logDate', e.target.value)} className={`form-control form-control-md`} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Equipment<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <AsyncSelect
                                                value={state.equipment}
                                                defaultOptions
                                                loadOptions={getEquipment}
                                                placeholder={
                                                    !state.logBookBusinessUnit?.projectId || !state.logDate 
                                                        ? "Please select Business Unit and Log Date first" 
                                                        : "Select Equipment"
                                                }
                                                onChange={handleEquipmentChange}
                                                styles={customStylesSelect}
                                                isDisabled={!state.logBookBusinessUnit?.projectId || !state.logDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Operator<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <AsyncSelect
                                                value={state.operator}
                                                defaultOptions
                                                loadOptions={getOperatorName}
                                                placeholder="Select Operator"
                                                onChange={handleOperatorNameChange}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="startingHrs" className="col-lg-2 col-form-label">Starting Hrs Meter<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input 
                                                type="number" 
                                                name="startingHrs" 
                                                id="startingHrs" 
                                                value={state.startingHrs} 
                                                onChange={(e) => handleInputOnChange('startingHrs', e.target.value)} 
                                                className={`form-control form-control-md`} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="endingHrs" className="col-lg-2 col-form-label">Ending Hrs Meter<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input 
                                                type="number" 
                                                name="endingHrs" 
                                                id="endingHrs" 
                                                value={state.endingHrs} 
                                                onChange={(e) => handleInputOnChange('endingHrs', e.target.value)} 
                                                className={`form-control form-control-md`} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="workSiteName" className="col-lg-2 col-form-label">Work Site Name<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input 
                                                type="text" 
                                                name="workSiteName" 
                                                id="workSiteName" 
                                                value={state.workSiteName} 
                                                onChange={(e) => handleInputOnChange('workSiteName', e.target.value)} 
                                                className={`form-control form-control-md`} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Work Type<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <Select
                                                value={state.workType}
                                                onChange={handleWorkTypeChange}
                                                placeholder="Select Work Type"
                                                options={state.workTypeList}
                                                menuPosition="fixed"
                                                isDisabled={state.projectId === ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Work Details<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <Select
                                                value={state.workDetails}
                                                onChange={handleWorkDetailsChange}
                                                placeholder="Select Work Details"
                                                options={state.workDetailsList}
                                                menuPosition="fixed"
                                                isDisabled={!state.workType.idDashboardEquipmentMajorTasks}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-lg-2 col-form-label">Multiple Time Entries</label>
                                        <div className="col-lg-6">
                                            <div className="checkbox-inline">
                                                <label className="checkbox">
                                                    <input
                                                        type="checkbox"
                                                        checked={state.isMultipleTimeEntries}
                                                        onChange={(e) => handleMultipleTimeEntriesChange(e.target.checked)}
                                                    />
                                                    <span></span>
                                                    Enable multiple time entries
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {state.isMultipleTimeEntries && (
                                        <div className="form-group row">
                                            <div className="col-lg-8">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Start Time</th>
                                                                <th>End Time</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {state.timeEntries.map((entry, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            value={entry.startTime}
                                                                            onChange={handleTimeEntryChange(index, 'startTime')}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            value={entry.endTime}
                                                                            onChange={handleTimeEntryChange(index, 'endTime')}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {state.timeEntries.length > 1 && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                                                                onClick={() => removeTimeEntry(index)}
                                                                            >
                                                                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                                                </span>
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={addTimeEntry}
                                                    >
                                                        Add Time Entry
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="form-group row">
                                        <label htmlFor="runningHrs" className="col-lg-2 col-form-label">Total Running Hours<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <InputMask 
                                                    mask="99" 
                                                    className="form-control" 
                                                    name="hrs" 
                                                    id="hrs" 
                                                    placeholder="HH"
                                                    value={state.runningHrs.hrs}
                                                    onChange={handleHourChange}
                                                    disabled={state.isMultipleTimeEntries}
                                                />
                                                <span className='input-group-text'>:</span>
                                                <InputMask 
                                                    mask="99" 
                                                    className="form-control" 
                                                    name="mins" 
                                                    id="mins" 
                                                    placeholder="MM"
                                                    value={state.runningHrs.mins}
                                                    onChange={handleMinuteChange}
                                                    disabled={state.isMultipleTimeEntries}
                                                />
                                            </div>
                                            <small className="form-text text-muted">
                                                {state.isMultipleTimeEntries 
                                                    ? "Total running hours will be calculated from time entries"
                                                    : "Enter hours (00-24) and minutes (00-59)"}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <div className="row">
                            <div className="col-4">
                            </div>
                            <div className="col-6">
                                <button type="submit" className="btn btn-success mr-2">Submit</button>
                                <button type="reset" className="btn btn-secondary">Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default LogBookRunningHourEntry;